// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-box-container {
  padding: 0;
  border-bottom: 1px solid #d4cfbe;
  background-color: #ece9dd;
}
.request-box-container:first-child {
  border-top: 1px solid #d4cfbe;
}
.request-box-container.selected {
  border-top: 5px solid #b39841;
  border-right: 1px solid #d4cfbe;
  background-color: #ffffff;
}
.request-box-container:hover:not(.disabled) {
  cursor: pointer;
  background-color: #ffffff;
}
.request-box-container:focus {
  outline-color: #b39841;
}
.request-box-container .request-box {
  padding: 10px 20px 10px 20px;
}
.request-box-container .request-box span:not(.highlight) {
  display: block;
  font-size: 15px;
  text-align: left;
}
.request-box-container .request-box span:not(.highlight).bold {
  font-family: Montserrat-SemiBold, sans-serif;
  margin-bottom: 5px;
}
.request-box-container .request-box span:not(.highlight).description {
  margin-bottom: 8px;
}
.request-box-container .request-box span:not(.highlight).title {
  color: #333333;
}
.request-box-container .request-box span:not(.highlight).date {
  color: #444444;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/selectable-list/selectable-list.component.less"],"names":[],"mappings":"AACA;EACE,UAAA;EACA,gCAAA;EACA,yBAAA;AAAF;AAEE;EACE,6BAAA;AAAJ;AAGE;EACE,6BAAA;EACA,+BAAA;EACA,yBAAA;AADJ;AAIE;EACE,eAAA;EACA,yBAAA;AAFJ;AAKE;EACE,sBAAA;AAHJ;AAlBA;EAyBI,4BAAA;AAJJ;AArBA;EA4BM,cAAA;EACA,eAAA;EACA,gBAAA;AAJN;AAMM;EACE,4CAAA;EACA,kBAAA;AAJR;AAOM;EACE,kBAAA;AALR;AAQM;EACE,cAAA;AANR;AASM;EACE,cAAA;AAPR","sourcesContent":["@import (reference) \"../../styles/variables.less\";\n.request-box-container {\n  padding: 0;\n  border-bottom: 1px solid @primary-50;\n  background-color: @neutral-background-light;\n\n  &:first-child {\n    border-top: 1px solid @primary-50;\n  }\n\n  &.selected {\n    border-top: 5px solid @primary-90;\n    border-right: 1px solid @primary-50;\n    background-color: @white;\n  }\n\n  &:hover:not(.disabled) {\n    cursor: pointer;\n    background-color: @white;\n  }\n\n  &:focus{\n    outline-color: @primary-90;\n  }\n\n  .request-box {\n    padding: 10px 20px 10px 20px;\n\n    span:not(.highlight) {\n      display: block;\n      font-size: 15px;\n      text-align: left;\n\n      &.bold {\n        font-family: Montserrat-SemiBold, sans-serif;\n        margin-bottom: 5px;\n      }\n\n      &.description {\n        margin-bottom: 8px;\n      }\n\n      &.title {\n        color: @secondary-base\n      }\n\n      &.date {\n        color: @secondary-90\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
